import { render, staticRenderFns } from "./TheHeaderSearchResults.vue?vue&type=template&id=63df50bb&scoped=true&"
import script from "./TheHeaderSearchResults.vue?vue&type=script&lang=js&"
export * from "./TheHeaderSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderSearchResults.vue?vue&type=style&index=0&id=63df50bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df50bb",
  null
  
)

export default component.exports